import { FC } from 'react';
import { CardType } from "./types"
import {
    IconDots,
    IconInfoCircle,
} from "@tabler/icons-react";

// @ts-ignore
const List: FC<CardType> = ({
    unit,
    estado,
    idProject,
    toggleBidder,
    openDrop,
    setOpenDrop,
    dropdownRef,
    handleSelect,
    handleOpen,
    handleCreateBooking,
}) => {
    const { base_price, id, name, status, landlordInfo, price_by_area, project_supports_multiple_bookings, updated_at, landlords_booked } = unit;

    return (
        <div className=" relative py-1 px-2 sm:px-2 rounded-[10px] bg-white border border-[#E0E0E0] h-full justify-around flex flex-row items-center gap-1 sm:gap-2">
            <div className="w-[300px] min-w-[300px] md:w-auto md:min-w-auto flex-1 px-1 flex flex-row items-center gap-2">
                <span className='text-xs text-[#757575]'>{updated_at}</span>
                <div className='min-w-20 w-20 md:min-w-24 md:w-24 [&_span]:!text-[9px] md:[&_span]:!text-xs [&_span]:!w-full [&_span]:inline-block [&_span]:text-center'>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${estado[status]?.class || ""}`}>
                        {estado[status]?.name || ""}
                    </span>
                </div>
                <h1 className="text-sm md:text-lg font-semibold text-[#212121] truncate">{name}</h1>
            </div>
            <div className='w-[200px] min-w-[200px] md:w-[300px] md:min-w-[300px] flex flex-col justify-center items-start'>
                {/* Lógica para mostrar el botón de pre-reservas y landlordInfo */}
                {status === "pre_booked" ? (
                    project_supports_multiple_bookings ? (
                        <button onClick={() => handleOpen(idProject, id)} className="mx-1 hover:bg-black/5 rounded-md duration-300 py-0.5 px-1" >
                            <div className="text-[#212121] text-sm flex items-center gap-1 text-left font-medium">
                                <IconInfoCircle color="#212121" className='size-5 min-w-5' />
                                {landlords_booked} pre-reservas
                            </div>
                        </button>
                    ) : (
                        landlordInfo && landlordInfo.id && (
                            <button onClick={() => handleOpen(idProject, id)} className="mx-1 hover:bg-black/5 rounded-md duration-300 py-0.5 px-1" >
                                <div className="text-[#212121] text-sm flex items-center gap-1 text-left font-medium">
                                    <IconInfoCircle color="#212121" className='size-5 min-w-5' />
                                    {landlordInfo.name}
                                </div>
                            </button>
                        )
                    )
                ) : (
                    (status === "taken" || status === "assigned" || status === "signing_promise") &&
                    landlordInfo && landlordInfo.id && (
                        <button onClick={toggleBidder} className="mx-1 hover:bg-black/5 rounded-md duration-300 yp-0 px-1.5">
                            <div className="text-[#212121] text-sm flex items-center gap-1 text-left font-medium">
                                <IconInfoCircle color="#212121" className='size-5 min-w-5' />
                                {landlordInfo.name}
                            </div>
                        </button>
                    )
                )}
            </div>
            <div className="w-[175px] min-w-[175px] md:w-[300px] md:min-w-[300px] flex flex-row items-center justify-start gap-1 sm:gap-2 flex-wrap md:flex-nowrap">
                <p className="text-sm font-semibold text-[#212121] whitespace-nowrap">
                    <span className="text-xs">Precio: </span><span className="font-normal text-sm text-[#757575]">{base_price}</span>
                </p>
                <p className="text-sm font-semibold text-[#212121] whitespace-nowrap">
                    <span className="text-xs">Precio por m²: </span><span className="font-normal text-sm text-[#757575]">{price_by_area}</span>
                </p>
            </div>
            {/* Reservar espacio para el botón de opciones */}
            <div className='min-w-[50px] w-[50px] flex justify-center items-between sm:w-auto sm:gap-2 relative'>
                <div className="flex items-center justify-center" style={{ width: 40 }}>
                    {(status === "assigned" || status === "created" || status === "disabled" || status === "available") ? (
                        <div className="text-left flex flex-col items-center justify-center" ref={dropdownRef}>
                            <button
                                onClick={() => setOpenDrop(!openDrop)}
                                className="inline-flex justify-between w-full rounded-md px-1 py-1 bg-white text-sm font-medium text-[#9E9E9E] hover:bg-gray-50 transition"
                            >
                                <IconDots />
                            </button>
                            <div
                                className={`absolute right-0 mt-2 w-52 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 transition-all duration-200 origin-top-right transform z-50 ${openDrop
                                    ? "opacity-100 scale-100"
                                    : "opacity-0 scale-95 pointer-events-none"
                                    }`}
                            >
                                {(status === "assigned") && (
                                    <div className="py-1 text-sm text-[#212121] font-medium">
                                        <button
                                            className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                            onClick={() => handleSelect("assigned")}
                                        >
                                            Liberar unidad
                                        </button>
                                    </div>
                                )}
                                {(status === "created" || status === "disabled") && (
                                    <div className="py-1 text-sm text-[#212121] font-medium">
                                        <button
                                            className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                            onClick={() => handleSelect("created")}
                                        >
                                            Habilitar unidad
                                        </button>
                                    </div>
                                )}
                                {status === "available" && (
                                    <>
                                        <div className="py-1 text-sm text-[#212121] font-medium">
                                            <button
                                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                                onClick={handleCreateBooking}
                                            >
                                                Crear una pre-reserva
                                            </button>
                                        </div>
                                        <div className="py-1 text-sm text-[#212121] font-medium">
                                            <button
                                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                                onClick={() => handleSelect("available")}
                                            >
                                                Deshabilitar unidad
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div style={{ width: 32, height: 32 }} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default List;

/* 
    Este archivo define un componente de lista que muestra tarjetas de información en un formato de lista.
    Cada tarjeta incluye detalles como el nombre, estado, precio y opciones de interacción.
    El componente maneja diferentes estados y muestra botones contextuales según el estado de la tarjeta.


    Daniel Bonilla - Septiembre 2025
*/